








































































import { Component, Emit, Model, Prop, Ref, Vue, Watch, PropSync } from 'vue-property-decorator';

@Component({})
export default class CardTitle extends Vue {
    @Prop({ default: false, type: Boolean })
    loading!: boolean;

    @Prop({ default: false, type: Boolean })
    btnClear!: boolean;

    @Prop({ default: false, type: Boolean })
    btnCancel!: boolean;

    @Prop({ default: false, type: Boolean })
    btnSave!: boolean;

    @Prop({ default: false, type: Boolean })
    btnUpdate!: boolean;

    @Prop({ default: 'Edit', type: String })
    title!: string;

    @Prop({ default: 'Save', type: String })
    saveBtnText!: string;

    @Prop({ default: false, type: Boolean })
    saveDisabled!: boolean;

    @Prop({ default: true, type: Boolean })
    btnClose!: boolean;

    @Prop({ default: false, type: Boolean })
    isMainPage!: boolean;

    @Emit('cancel')
    private cancel() {}

    @Emit('save')
    private save() {}

    @Emit('clear')
    private clear() {}

    @Emit('update')
    private update() {}

    @Emit('close')
    private close() {}
}
